(() => {
  const cleanupStyle = document.createElement('style');
  cleanupStyle.textContent = '.badge--onsale,countdown-timer{display:none!important}';
  document.head.appendChild(cleanupStyle);

  const legacySuffix = /\s*-\s*(?:VAOCOM|NONEOV|BLUE MOUNT)(?:™)?\s*$/i;
  const legacyInPageTitle = /\s*-\s*(?:VAOCOM|NONEOV|BLUE MOUNT)(?:™)?(?=\s*(?:–|-|$))/gi;

  const selectors = [
    '.card-information__text',
    '.product__title',
    '.sticky-cart__content-heading',
    '.cart-notification-product__name',
    '.cart-item__name',
    '.predictive-search__item-heading',
    '.quick-view__summary .product__title'
  ].join(',');

  const cleanTextNode = (node) => {
    if (!node || !node.nodeValue) return;
    const cleaned = node.nodeValue.replace(legacySuffix, '');
    if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
  };

  const cleanElement = (element) => {
    if (!element) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(cleanTextNode);
  };

  const cleanRoot = (root = document) => {
    if (root.nodeType === 1 && root.matches && root.matches(selectors)) cleanElement(root);
    if (root.querySelectorAll) root.querySelectorAll(selectors).forEach(cleanElement);
  };

  const cleanPageTitle = () => {
    const cleaned = document.title.replace(legacyInPageTitle, '');
    if (cleaned !== document.title) document.title = cleaned;
  };

  const run = () => {
    cleanRoot(document);
    cleanPageTitle();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;
          if (parent && (parent.matches(selectors) || parent.closest(selectors))) {
            cleanTextNode(mutation.target);
          }
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) cleanRoot(node);
          if (node.nodeType === 3) {
            const parent = node.parentElement;
            if (parent && (parent.matches(selectors) || parent.closest(selectors))) cleanTextNode(node);
          }
        });
      });
      cleanPageTitle();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
